import { object_map } from "@pdfking/rfunc"
import { Identity } from "@pdfking/tfunc"
import encode from "@pdfking/workflow/utils/encode"
import { url_query_encode } from "@pdfking/workflow/utils/urlutilities"

export const DEFAULT_VIEW = "home"
export const NAV_VIEW = "menu"
export const SEARCH_VIEW = "search"
export const SLIDESHOW_VIEW = "slideshow"
export const MARKDOWN_VIEW = "markdown"
export const FILECHECK_VIEW = "filecheck"
export const PROMPT_VIEW = "prompt"

const query = (
  name: string,
  component: (() => Promise<any>) | null,
  export_name: string
) => ({
  component,
  export_name,
  name,
  navigate: (params: Record<string, any>) => {
    const qs = url_query_encode(params)
    return `/${name}${qs ? `?${qs}` : ""}`
  },
  parse_props: (_rest: string, query: Record<string, string>) => query,
})

const b64 = (
  name: string,
  component: () => Promise<any>,
  export_name: string
) => ({
  component,
  export_name,
  name,
  navigate: (params: any) => `/${name}/${encode.dumps(params)}`,
  parse_props: (rest: string, _query: Record<string, string>) => {
    return rest ? encode.loads(rest) : {}
  },
})

const routes = [
  query(DEFAULT_VIEW, null, ""),
  query(
    NAV_VIEW,
    () => import(/* webpackChunkName: "navigation" */ "./views/Nav"),
    "Nav"
  ),
  query(
    SEARCH_VIEW,
    () => import(/* webpackChunkName: "navigation" */ "./views/Search"),
    "Search"
  ),
  b64(
    SLIDESHOW_VIEW,
    () => import(/* webpackChunkName: "slideshow" */ "./views/Slideshow"),
    "Slideshow"
  ),
  b64(
    MARKDOWN_VIEW,
    () => import(/* webpackChunkName: "markdown" */ "./views/Markdown"),
    "Markdown"
  ),
  b64(
    FILECHECK_VIEW,
    () =>
      import(/* webpackChunkName: "filecheck" */ "./views/pdfview/Pdfmodal"),
    "Pdfmodal"
  ),
  b64(
    PROMPT_VIEW,
    () => import(/* webpackChunkName: "prompt" */ "./views/Prompt"),
    "Prompt"
  ),
]

export default object_map(v => v.name, Identity, routes)
